import _extends from "@babel/runtime/helpers/esm/extends";
import { FIELD_DEFAULT_ERROR, FIELD_DEFAULT_VALUE, FIELD_INITIAL_STATIC_VALUES, FIELD_KEY_DEFAULT_VALUE, FIELD_KEY_DEFAULT_VALUE_ERROR } from '../constants';
import { mapFieldValueAndError } from '../helpers';
import { updateFieldStateWithCallback } from '../state';
/**
 * Reset field, but ignoring default value
 * @param namespace
 * @param fieldName
 */

export var clearField = function clearField(namespace, fieldName) {
  updateFieldStateWithCallback(namespace, fieldName, function () {
    return _extends({}, FIELD_INITIAL_STATIC_VALUES, mapFieldValueAndError(FIELD_DEFAULT_VALUE, FIELD_DEFAULT_ERROR));
  });
};
/**
 * Reset field to default state and setting last provided default value
 * @param namespace
 * @param fieldName
 */

export var resetField = function resetField(namespace, fieldName) {
  // reset field to default state and setting last provided default value
  updateFieldStateWithCallback(namespace, fieldName, function (currentState) {
    return _extends({}, FIELD_INITIAL_STATIC_VALUES, mapFieldValueAndError(currentState[FIELD_KEY_DEFAULT_VALUE] || FIELD_DEFAULT_VALUE, currentState[FIELD_KEY_DEFAULT_VALUE_ERROR] || FIELD_DEFAULT_ERROR));
  });
};